var CommunityChallenge = {

    loading: false,
    init: function() {
        if (!CommunityChallenge.loading) {
            CommunityChallenge.loading = true;
            Api.post('/ghosts/cc_oct21_sticker_collector', {}, function(r) {
                let btn = document.getElementById('cc_stickers_oct21_collector_1');
                if (r.success) {
                    Alert.push([{type: 'success', text: '¡Gracias por ayudar a la comunidad! Tus premios por el desafío a la comunidad han sido sumados a tu cuenta.', icon: 'circle-check'}]);
                    btn.remove();
                } else {
                    switch (r.error.identifier) {
                        case 'already_claimed':
                            Alert.push([{type: 'danger', text: '¡Oops! Ya has sido recompensado por este reto.', icon: 'circle-alert'}]);
                            btn.remove();
                            break;
                        case 'requirements_not_completed':
                            Alert.push([{type: 'danger', text: '¡Oops! No cumples con los requisitos para reclamar este premio.', icon: 'circle-alert'}]);
                            break;
                    }
                }
                CommunityChallenge.loading = false;
            });

        }
    }



}
